$('body').on('click', '#calculateFromModalPdp', function (e) {
    e.preventDefault();

    var inputUnderbrowSize = $('#contact-form-question-underbrow-from-pdp').val();
    var inputCupSize = $('#contact-form-question-cup-from-pdp').val();

    if (inputUnderbrowSize != undefined && inputCupSize != undefined && inputUnderbrowSize != '' && inputCupSize != '') {
        var jsonUnderbrowTable = window.FindYourSizeData.findYourSizeData;
        var underbrowTable = JSON.parse(jsonUnderbrowTable);
        var intUnderbrowSize = $('#findYourSizeModal-size-form-inch:checked').length > 0 ? parseInt(inputUnderbrowSize / 0.393700) : parseInt(inputUnderbrowSize);
        var intCupSize = $('#findYourSizeModal-size-form-inch:checked').length > 0 ? parseInt(inputCupSize / 0.393700) : parseInt(inputCupSize);
        calculateBraSizeFromPdp(intUnderbrowSize, intCupSize, underbrowTable);
    } else {
        if (inputUnderbrowSize == undefined || inputUnderbrowSize == '') {
            $('#contact-form-question-underbrow-from-pdp').addClass('is-invalid-input');
            $('#errorUnderbrow').removeClass('hidden');
        }
        if (inputCupSize == undefined || inputCupSize == '') {
            $('#contact-form-question-cup-from-pdp').addClass('is-invalid-input');
            $('#errorCup').removeClass('hidden');
        }
    }
});

$('body').on('click', '.js-findYourSizeModal-measure-unit-items input', function (e) {
    let unit = $(this).data('unit');
    $('.js-findYourSizeModal-fieldset-item-unit').addClass('hidden');
    $('.js-findYourSizeModal-fieldset-item-unit.' + unit).removeClass('hidden');
});

$('body').on('focus', '#contact-form-question-underbrow-from-pdp', function (e) {
    e.preventDefault();
    $('#contact-form-question-underbrow-from-pdp').removeClass('is-invalid-input');
    $('#errorUnderbrow').addClass('hidden');
});

$('body').on('focus', '#contact-form-question-cup-from-pdp', function (e) {
    e.preventDefault();
    $('#contact-form-question-cup-from-pdp').removeClass('is-invalid-input');
    $('#errorCup').addClass('hidden');
});

$('input').focus(function () {
    $(this).next('span').css('display', 'block');
});

function calculateBraSizeFromPdp (inputUnderbrowSize, inputCupSize, underbrowTable) {
    var country = $('#countrySelector').attr('data-country');

    var jsonCircTable = window.FindYourSizeDataCirc.findYourSizeDataCirc;
    var circTable = JSON.parse(jsonCircTable);
    var underbrowSize;
    var cupSize;
    var eu = false;
    for (var key in underbrowTable) {
        if (inputUnderbrowSize >= underbrowTable[key].from && inputUnderbrowSize <= underbrowTable[key].to) {
            switch (country) {
            case 'it':
                underbrowSize = underbrowTable[key].it;
                break;
            case 'es':
                underbrowSize = underbrowTable[key].es;
                break;
            case 'fr':
                underbrowSize = underbrowTable[key].fr;
                break;
            case 'us':
                underbrowSize = underbrowTable[key].us;
                break;
            case 'gb':
                underbrowSize = underbrowTable[key].gb;
                break;
            case 'pt':
                underbrowSize = underbrowTable[key].pt;
                break;
            case 'hk':
                underbrowSize = underbrowTable[key].hk;
                break;
            case 'lu':
                underbrowSize = underbrowTable[key].lu;
                break;
            default:
                eu = true;
                underbrowSize = underbrowTable[key].eu;
                break;
            }
            break;
        }
    }

    if (eu == true) {
        country = 'eu';
    }
    for (var k in circTable[country + '_' + underbrowSize]) {
        if (inputCupSize >= circTable[country + '_' + underbrowSize][k].from && inputCupSize <= circTable[country + '_' + underbrowSize][k].to) {
            cupSize = k;
            break;
        }
    }

    if (underbrowSize != undefined && cupSize != undefined) {
        $('#measure-not-valid-from-pdp').hide();
        $('#bra-results-from-pdp').show();
        $('#suggested-sizes-from-pdp').show();
        $('#box-result-size-from-pdp').show();
        $('#box-result-size-from-pdp-measure-valid').show();
        document.getElementById('bra-results-from-pdp').firstElementChild.innerText = underbrowSize + cupSize;
        $('#box-message-size').removeAttr('hidden');
        var suggestedSizes;

        switch (country) {
        case 'it':
            suggestedSizes = calculateTableFromPdp(underbrowSize, cupSize);
            break;
        case 'es':
            suggestedSizes = calculateTableFromPdpESFRLU(underbrowSize, cupSize);
            break;
        case 'fr':
            suggestedSizes = calculateTableFromPdpESFRLU(underbrowSize, cupSize);
            break;
        case 'us':
            suggestedSizes = calculateTableFromPdpUS(underbrowSize, cupSize);
            break;
        case 'gb':
            suggestedSizes = calculateTableFromPdpUK(underbrowSize, cupSize);
            break;
        case 'hk':
            suggestedSizes = calculateTableFromPdpHK(underbrowSize, cupSize);
            break;
        case 'pt':
            suggestedSizes = calculateTableFromPdpPT(underbrowSize, cupSize);
            break;
        case 'lu':
            suggestedSizes = calculateTableFromPdpESFRLU(underbrowSize, cupSize);
            break;
        default:
            suggestedSizes = calculateTableFromPdpEU(underbrowSize, cupSize);
            break;
        }

        // $('#measure-not-valid-from-pdp').hide();
        // $('#bra-results-from-pdp').show();
        // $('#box-result-size-from-pdp').show();
        // $('#box-result-size-from-pdp-measure-valid').show();
        // document.getElementById('bra-results-from-pdp').innerHTML = underbrowSize+cupSize;
        // $('#box-message-size').removeAttr('hidden');
        // var suggestedSizes = calculateTableFromPdp(underbrowSize,cupSize);
        if(suggestedSizes.length !== 0){
            var suggestedSizesString = '';
            for (var i = 0; i < suggestedSizes.length; i++) {
                suggestedSizesString = suggestedSizesString.concat(suggestedSizes[i]);
                if (i != suggestedSizes.length - 1) {
                    suggestedSizesString = suggestedSizesString.concat(',');
                } else {
                    suggestedSizesString = suggestedSizesString.concat('.');
                }
            }
            document.getElementById('suggested-sizes-from-pdp').firstElementChild.innerText = suggestedSizesString;
            $('#bra-results-from-pdp').css('margin-bottom', '0');
        } else {
            $('#suggested-sizes-from-pdp').hide();
            $('#bra-results-from-pdp').css('margin-bottom', 'revert');
        }
    } else {
        $('#bra-results-from-pdp').hide();
        $('#suggested-sizes-from-pdp').hide();
        $('#box-result-size-from-pdp').hide();
        $('#measure-not-valid-from-pdp').show();
        $('#box-result-size-from-pdp-measure-valid').hide();
    }
}

function calculateTableFromPdp (underbrowSize, cupSize) {
    var suggestedSizes = [];
    var initialCupSize = cupSize;
    var initialUnderBrowSize = underbrowSize;
    var arrSizes = ['A', 'B', 'C', 'D', 'E', 'F'];

    for (var i = underbrowSize; i < 6; i++) {
        if (cupSize == 'A') {
            break;
        }
        var PrevUnderbrowSize = i + 1;
        var prevCupSize = arrSizes[arrSizes.indexOf(cupSize) - 1];
        var cupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        suggestedSizes.push(id);
    }

    for (var i = initialUnderBrowSize; i > 1; i--) {
        if (initialCupSize == 'F') {
            break;
        }
        var PrevUnderbrowSize = i - 1;
        var prevCupSize = arrSizes[arrSizes.indexOf(initialCupSize) + 1];
        var initialCupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        suggestedSizes.push(id);
    }

    return suggestedSizes;
}

function calculateTableFromPdpESFRLU (underbrowSize, cupSize) {
    var suggestedSizes = [];
    var initialCupSize = cupSize;
    var initialUnderBrowSize = underbrowSize;
    var arrSizes = ['A', 'B', 'C', 'D', 'E', 'F'];

    for (var i = underbrowSize; i < 105; i += 5) {
        if (cupSize == 'A') {
            break;
        }
        var PrevUnderbrowSize = i + 5;
        var prevCupSize = arrSizes[arrSizes.indexOf(cupSize) - 1];
        var cupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        suggestedSizes.push(id);
    }

    for (var i = initialUnderBrowSize; i > 80; i -= 5) {
        if (initialCupSize == 'F') {
            break;
        }
        var PrevUnderbrowSize = i - 5;
        var prevCupSize = arrSizes[arrSizes.indexOf(initialCupSize) + 1];
        var initialCupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        suggestedSizes.push(id);
    }

    return suggestedSizes;
}

function calculateTableFromPdpUS (underbrowSize, cupSize) {
    var suggestedSizes = [];
    var initialCupSize = cupSize;
    var initialUnderBrowSize = underbrowSize;
    var arrSizes = ['A', 'B', 'C', 'D', 'DD', 'DDD'];

    if (underbrowSize == 43) {
        underbrowSize = underbrowSize - 1;
    }
    for (var i = underbrowSize; i < 42; i += 2) {
        if (cupSize == 'A') {
            break;
        }
        var PrevUnderbrowSize = i + 2;
        var prevCupSize = arrSizes[arrSizes.indexOf(cupSize) - 1];
        var cupSize = prevCupSize;
        if (PrevUnderbrowSize == 42) {
            PrevUnderbrowSize++;
        }
        var id = '' + PrevUnderbrowSize + prevCupSize;
        suggestedSizes.push(id);
    }

    if (initialUnderBrowSize == 43) {
        initialUnderBrowSize = initialUnderBrowSize - 1;
    }

    for (var i = initialUnderBrowSize; i > 32; i -= 2) {
        if (initialCupSize == 'F') {
            break;
        }
        var PrevUnderbrowSize = i - 2;
        var prevCupSize = arrSizes[arrSizes.indexOf(initialCupSize) + 1];
        var initialCupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        suggestedSizes.push(id);
    }

    return suggestedSizes;
}

function calculateTableFromPdpEU (underbrowSize, cupSize) {
    var suggestedSizes = [];
    var initialCupSize = cupSize;
    var initialUnderBrowSize = underbrowSize;
    var arrSizes = ['A', 'B', 'C', 'D', 'E', 'F'];

    for (var i = underbrowSize; i < 95; i += 5) {
        if (cupSize == 'A') {
            break;
        }
        var PrevUnderbrowSize = i + 5;
        var prevCupSize = arrSizes[arrSizes.indexOf(cupSize) - 1];
        var cupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        suggestedSizes.push(id);
    }

    for (var i = initialUnderBrowSize; i > 70; i -= 5) {
        if (initialCupSize == 'F') {
            break;
        }
        var PrevUnderbrowSize = i - 5;
        var prevCupSize = arrSizes[arrSizes.indexOf(initialCupSize) + 1];
        var initialCupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        suggestedSizes.push(id);
    }

    return suggestedSizes;
}

function calculateTableFromPdpUK (underbrowSize, cupSize) {
    var suggestedSizes = [];
    var initialCupSize = cupSize;
    var initialUnderBrowSize = underbrowSize;
    var arrSizes = ['A', 'B', 'C', 'D', 'DD', 'F'];

    if (underbrowSize == 43) {
        underbrowSize = underbrowSize - 1;
    }
    for (var i = underbrowSize; i < 42; i += 2) {
        if (cupSize == 'A') {
            break;
        }
        var PrevUnderbrowSize = i + 2;
        var prevCupSize = arrSizes[arrSizes.indexOf(cupSize) - 1];
        var cupSize = prevCupSize;
        if (PrevUnderbrowSize == 42) {
            PrevUnderbrowSize++;
        }
        var id = '' + PrevUnderbrowSize + prevCupSize;
        suggestedSizes.push(id);
    }

    if (initialUnderBrowSize == 43) {
        initialUnderBrowSize = initialUnderBrowSize - 1;
    }

    for (var i = initialUnderBrowSize; i > 32; i -= 2) {
        if (initialCupSize == 'F') {
            break;
        }
        var PrevUnderbrowSize = i - 2;
        var prevCupSize = arrSizes[arrSizes.indexOf(initialCupSize) + 1];
        var initialCupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        suggestedSizes.push(id);
    }

    return suggestedSizes;
}

function calculateTableFromPdpPT (underbrowSize, cupSize) {
    var suggestedSizes = [];
    var initialCupSize = cupSize;
    var initialUnderBrowSize = underbrowSize;
    var arrSizes = ['A', 'B', 'C', 'D', 'E', 'F'];

    if (underbrowSize == 43) {
        underbrowSize = underbrowSize - 1;
    }
    for (var i = underbrowSize; i < 42; i += 2) {
        if (cupSize == 'A') {
            break;
        }
        var PrevUnderbrowSize = i + 2;
        var prevCupSize = arrSizes[arrSizes.indexOf(cupSize) - 1];
        var cupSize = prevCupSize;
        if (PrevUnderbrowSize == 42) {
            PrevUnderbrowSize++;
        }
        var id = '' + PrevUnderbrowSize + prevCupSize;
        suggestedSizes.push(id);
    }

    if (initialUnderBrowSize == 43) {
        initialUnderBrowSize = initialUnderBrowSize - 1;
    }

    for (var i = initialUnderBrowSize; i > 32; i -= 2) {
        if (initialCupSize == 'F') {
            break;
        }
        var PrevUnderbrowSize = i - 2;
        var prevCupSize = arrSizes[arrSizes.indexOf(initialCupSize) + 1];
        var initialCupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        suggestedSizes.push(id);
    }

    return suggestedSizes;
}

function calculateTableFromPdpHK (underbrowSize, cupSize) {
    var suggestedSizes = [];
    var initialCupSize = cupSize;
    var initialUnderBrowSize = underbrowSize;
    var arrSizes = ['A', 'B', 'C', 'D', 'E', 'F'];

    if (underbrowSize == 43) {
        underbrowSize = underbrowSize - 1;
    }
    for (var i = underbrowSize; i < 42; i += 2) {
        if (cupSize == 'A') {
            break;
        }
        var PrevUnderbrowSize = i + 2;
        var prevCupSize = arrSizes[arrSizes.indexOf(cupSize) - 1];
        var cupSize = prevCupSize;
        if (PrevUnderbrowSize == 42) {
            PrevUnderbrowSize++;
        }
        var id = '' + PrevUnderbrowSize + prevCupSize;
        suggestedSizes.push(id);
    }

    if (initialUnderBrowSize == 43) {
        initialUnderBrowSize = initialUnderBrowSize - 1;
    }

    for (var i = initialUnderBrowSize; i > 32; i -= 2) {
        if (initialCupSize == 'F') {
            break;
        }
        var PrevUnderbrowSize = i - 2;
        var prevCupSize = arrSizes[arrSizes.indexOf(initialCupSize) + 1];
        var initialCupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        suggestedSizes.push(id);
    }

    return suggestedSizes;
}
